export default "__VITE_ASSET__0bbcb268__"